import { useEffect, useState } from 'react';
import {obtenerUsuariosTerapeutasOcupacionales,
    obtenerUsuariosPsicologas,obtenerUsuariosOtros, editarSesion,obtenerSesionPorSesionId} from '../data/FichaConsultante';
import { useContext } from "react";
import { AuthContext } from "auth";
import moment from 'moment';
import 'moment/locale/es';



export const useFichaSesion= (SesionId) => {
    var {user}= useContext(AuthContext)
  
    const [sesionFicha,setSesionFicha]=useState({sesionId:SesionId});
    const [usuariosTo,setUsuariosTo]=useState();
    const [usuariosSicologas,setUsuariosSicologas]=useState();
    const [usuariosOtros,setUsuariosOtros]=useState();
    const [respuestaEditarSesion, setRespuestaEditarSesion] = useState({mensajeTexto:"",estado:false});

      
    const updateRespuestaEditarSesion=async =>{
        setTimeout(function() {
            setRespuestaEditarSesion({mensajeTexto:"",estado:false});
        }, 4000);
    }
  
    const getUsuariosTerapeutasOcupacionales= async() => {
        const respuesta=await obtenerUsuariosTerapeutasOcupacionales(user.Token);
        setUsuariosTo(respuesta)
    }
    const getUsuariosPsicologas= async() => {
        const respuesta=await obtenerUsuariosPsicologas(user.Token);
        setUsuariosSicologas(respuesta)
    }
    const getUsuariosOtros= async() => {
        const respuesta=await obtenerUsuariosOtros(user.Token);
        setUsuariosOtros(respuesta)
            
    }
    const getSesionFicha= async() => {
        const respuesta=await obtenerSesionPorSesionId(SesionId,user.Token);

        setSesionFicha(
            {
                Id:respuesta.Id,
                FechaSesion:respuesta.FechaSesion,
                Comentario:respuesta.Comentario,
                ProfesionalOtro:JSON.parse(respuesta.ProfesionalOtro),
                ProfesionalSicologa:JSON.parse(respuesta.ProfesionalSicologa),
                ProfesionalTo:JSON.parse(respuesta.ProfesionalTo),
                NombreSocial:respuesta.NombreSocial,
                Rut:respuesta.Rut
                

            });
    
    }      
    const editSesion=async(SesionPorEditar)=>{
        if(SesionPorEditar!=null){
          
            //const d=moment(sesionFicha?.FechaSesion);
            //d.local(true)
            //sesionFicha.FechaSesion=d;
            const respuesta=await editarSesion(SesionPorEditar,user.Token);
            setRespuestaEditarSesion({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
    
    useEffect( () => {
        async function setFichaSesionFuncion() {
            getSesionFicha();
            getUsuariosOtros();
            getUsuariosPsicologas();
            getUsuariosTerapeutasOcupacionales();
        }
        setFichaSesionFuncion();
    }, []); 

    return {
      
        sesionFicha,
        setSesionFicha,
        getUsuariosTerapeutasOcupacionales,
        getUsuariosPsicologas,
        getUsuariosOtros,
        usuariosTo,
        usuariosSicologas,
        usuariosOtros,
        editSesion,
        respuestaEditarSesion,
        updateRespuestaEditarSesion,
        getSesionFicha
               
       
    }
}
